<form class="needs-validation" novalidate>
  <div class="col-md-12">
    <div class="border rounded-2 p-4 kdiv">
      <h3 class="text-center">Regional Kaizen System Dashboard</h3>
      <div class="row">
        <div class="col-md-10">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search Kaizen" #searchCriteria
              (keydown.enter)="OnSearch(searchCriteria.value)">
            <button class="btn btn-outline-info fa fa-search" type="button" (click)="OnSearch(searchCriteria.value)">
              Search
            </button>
          </div>
        </div>
        <div class="col-md-2 d-flex align-items-center">
          <a [routerLink]="['/advancedSearch']">Advanced Search</a>
        </div>
      </div>
      <br>
      <div class="boldtext">Total {{totalItems}} Kaizens</div>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z1" matSort>

        <ng-container matColumnDef="kaizenNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class=" col-form-label">KZ NUM#</th>
          <td mat-cell *matCellDef="let element">K{{element.kaizenNumber}}</td>
        </ng-container>

        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>NAMC</th>
          <td mat-cell *matCellDef="let element">{{element.company}}</td>
        </ng-container>

        <ng-container matColumnDef="line">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Line</th>
          <td mat-cell *matCellDef="let element">{{element.line}}</td>
        </ng-container>

        <ng-container matColumnDef="shop">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Shop</th>
          <td mat-cell *matCellDef="let element">{{shopSizer(element.shop)}}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let element">{{element.name}}</td>
        </ng-container>

        <ng-container matColumnDef="account">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
          <td mat-cell *matCellDef="let element">{{element.account}}</td>
        </ng-container>

        <ng-container matColumnDef="fySavings">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Est Yearly Savings</th>
          <td mat-cell *matCellDef="let element">{{element.fySavings | currency:'USD':'symbol':'1.0'}}</td>
        </ng-container>

        <ng-container matColumnDef="internalTrackingNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Int Tracking No</th>
          <td mat-cell *matCellDef="let element">{{element.internalTrackingNo}}</td>
        </ng-container>

        <ng-container matColumnDef="trackingRef1">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tracking Ref 1</th>
          <td mat-cell *matCellDef="let element">{{element.trackingRef1}}</td>
        </ng-container>

        <ng-container matColumnDef="trackingRef2">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tracking Ref 2</th>
          <td mat-cell *matCellDef="let element">{{element.trackingRef2}}</td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">{{element.state}}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="'/kaizenDetails/' + element.kaizenId">Details</a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

<mat-paginator [length]="totalItems"
               [pageSize]="pageSize"
               [pageIndex]="pageNumber - 1"
               [pageSizeOptions]="[25, 50, 100]"
               showFirstLastButtons
               (page)="onPageChange($event)">
</mat-paginator>
    </div>
  </div>
</form>